import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { delay } from 'lodash';

const WARNING_DELAY = 5000;

export default class ASQFinishSurveyButton extends React.PureComponent {
  static propTypes = {
    isValid: PropTypes.bool.isRequired,
    message: PropTypes.string,
    onFinishSurvey: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isOpen: false, timerId: 0 };
  }

  showCallout = () => {
    if (this.state.isOpen) return;
    const timerId = delay(this.hideCallout, WARNING_DELAY);
    this.setState({isOpen: true, timerId });
  }

  hideCallout = () => {
    if (this.state.timerId) clearTimeout(this.state.timerId);
    this.setState({ isOpen: false, timerId: 0 });
  }

  render() {
    const { isValid, message, onFinishSurvey } = this.props;
    const clsFinish = classNames('o-sp-button o-sp-button--base o-sp-button--primary',
      { 'u-faded': !isValid }
    );
    return isValid ?
      <div className='text-center u-margin-top--large u-margin-bottom--base'>
        <a className={clsFinish} onClick={onFinishSurvey}>Finish Survey</a>
      </div> :
      <div className='text-center u-margin-top--large u-margin-bottom--base'>
        {this.state.isOpen &&
          <div className="callout warning u-margin-top--large text-left u-padding-top--base">
            <span className='u-padding-right--small'>{message}</span>
            <button className="close-button" aria-label="Dismiss alert" type="button" onClick={this.hideCallout}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div> }
        <a className={clsFinish} onClick={this.showCallout}>Finish Survey</a>
      </div>
  }
}
